import React, { useState } from 'react';

import Col from 'react-bootstrap/Col';
import ErrorBoundary from '../../utilities/ErrorBoundary';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row';
import useData from '../../utilities/useData';

const EditView = ({
    children,
    customerId,
    divId,
    getUrl,
    title
}) => {
    const { data, fetchData } = useData(getUrl);
    const [editId, setEditId] = useState(undefined);
    const [canAdd, setCanAdd] = useState(true);

    const cancelEdit = () => {
        setEditId(undefined);
        fetchData();
        setTimeout(() => setCanAdd(true), 300);
    }

    const editItem = (id) => {
        if (editId !== id) {
            setCanAdd(false);
            if (editId !== undefined) {
                // make sure we close any open editors
                setEditId(undefined);
                setTimeout(() => setEditId(id), 100);
            } else {
                setEditId(id);
            }
        }
    }

    const list = React.cloneElement(children[0], {
        addItem: () => editItem(0),
        canAdd: canAdd && data.canCreate,
        data: data,
        editItem: editItem,
        fetchData: fetchData
    });

    const editor = React.cloneElement(children[1], {
        cancelEdit: cancelEdit,
        customerId: customerId,
        editId: editId,
        fetchData: fetchData,
        setCanAdd: setCanAdd
    });

    return (
        <Row className="pt-4">
            <div className="jump-target-wrapper">
                <div id={divId} className="jump-target">
                </div>
            </div>
            <Col>
                <div className="index-head">
                    {title}
                </div>
                <Row className="mt-3">
                    <Col>
                    </Col>
                </Row>
                <ErrorBoundary>
                    <Row>
                        <Col>
                            {list}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {editor}
                        </Col>
                    </Row>
                </ErrorBoundary>
            </Col>
        </Row>
    );
}

EditView.propTypes = {
    children: PropTypes.array.isRequired,
    customerId: PropTypes.number,
    getUrl: PropTypes.string.isRequired
};

export default EditView;